import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import Footer from "../components/footer";
import Header from "../components/header";
import TopNavabr from "../components/topNavabr";
import { useScrollTop } from "../hook/useScrollTop";
import sitemapImg from "../images/site-map.jpg";

const Sitemap = () => {
  useScrollTop();
  return (
    <>
      <Helmet>
        <title>AFRO || Sitemap</title>
      </Helmet>
      <TopNavabr />
      <Header bannerBackground="image" staticImageURL={sitemapImg}>
        <div className="pt-7 pb-5 text-center">
          <h1 className="fs-56 mt-4 text-capitalize flex align-items-center header-background-image-size">
            Sitemap
          </h1>
        </div>
      </Header>
      <section className="container-fluid">
        <section className="ms-47 me-47 pt-7 pb-7">
          <div className="row py-5 border-bottom">
            <div className="col-12 col-md-4">
              <Link
                to="/about/overview"
                className="text-decoration-none fs-24 text-dark"
              >
                About Us
              </Link>
            </div>
            <div className="col-12 col-md-4">
              <Link
                to="/about/overview"
                className="fs-16 text-decoration-none text-orange-ryb d-block gilroy-bold"
              >
                Overview
              </Link>
              <Link
                to="/about/business-model"
                className="fs-16 text-decoration-none text-orange-ryb d-block gilroy-bold"
              >
                Business Model
              </Link>
              <Link
                to="/about/board-of-directors"
                className="fs-16 text-decoration-none text-orange-ryb d-block gilroy-bold"
              >
                Board of Directors
              </Link>
              <Link
                to="/about/executive-and-leadership-team"
                className="fs-16 text-decoration-none text-orange-ryb d-block gilroy-bold"
              >
                Executive and Leadership Team
              </Link>
              <Link
                to="/about/our-value-and-approach"
                className="fs-16 text-decoration-none text-orange-ryb d-block gilroy-bold"
              >
                Our value and approach
              </Link>
            </div>
            <div className="col-12 col-md-4">
              <Link
                to="/about/code-of-conducts-and-policies"
                className="fs-16 text-decoration-none text-orange-ryb d-block gilroy-bold"
              >
                Code of Conducts And Policies
              </Link>
              <Link
                to="/about/diversity-and-inclusion"
                className="fs-16 text-decoration-none text-orange-ryb d-block gilroy-bold"
              >
                Diversity and Inclusion
              </Link>
            </div>
          </div>
          <div className="py-5 border-bottom">
            <Link
              to="/board-of-directors"
              className="text-decoration-none fs-24 text-dark"
            >
              Industries
            </Link>
          </div>
          <div className="py-5 border-bottom">
            <Link
              to="/where-we work"
              className="text-decoration-none fs-24 text-dark"
            >
              Where We Works
            </Link>
          </div>
          <div className="py-5 border-bottom">
            <Link
              to="/solutions"
              className="text-decoration-none fs-24 text-dark"
            >
              Solution
            </Link>
          </div>
          <div className="py-5 border-bottom">
            <Link
              to="/partners"
              className="text-decoration-none fs-24 text-dark"
            >
              Partners
            </Link>
          </div>
          <div className="py-5 border-bottom">
            <Link
              to="/sustainability"
              className="text-decoration-none fs-24 text-dark"
            >
              Sustainability
            </Link>
          </div>
          <div className="py-5 border-bottom">
            <Link
              to="/media-center"
              className="text-decoration-none fs-24 text-dark"
            >
              Media Center
            </Link>
          </div>
          <div className="py-5 border-bottom">
            <Link
              to="/afro-academy"
              className="text-decoration-none fs-24 text-dark"
            >
              Afro Academy
            </Link>
          </div>
          <div className="py-5 border-bottom">
            <Link to="/career" className="text-decoration-none fs-24 text-dark">
              Career
            </Link>
          </div>
          <div className="py-5 border-bottom">
            <Link
              to="/suppliers"
              className="text-decoration-none fs-24 text-dark"
            >
              Suppliers
            </Link>
          </div>
          <div className="py-5 border-bottom">
            <Link
              to="/investors"
              className="text-decoration-none fs-24 text-dark"
            >
              {" "}
              Investors
            </Link>
          </div>
          <div className="py-5 border-bottom">
            <Link
              to="/solar-alternative-energy"
              className="text-decoration-none fs-24 text-dark"
            >
              Solar & Alternative Energy
            </Link>
          </div>
          <div className="py-5 border-bottom">
            <Link
              to="/agriculture"
              className="text-decoration-none fs-24 text-dark"
            >
              Agriculture
            </Link>
          </div>
          <div className="py-5 border-bottom">
            <Link
              to="/smart-homes"
              className="text-decoration-none fs-24 text-dark"
            >
              Smart Homes
            </Link>
          </div>
          <div className="py-5 border-bottom">
            <Link
              to="/software-apps"
              className="text-decoration-none fs-24 text-dark"
            >
              Software & Apps
            </Link>
          </div>
          <div className="py-5 border-bottom">
            <Link
              to="/digital-marketing"
              className="text-decoration-none fs-24 text-dark"
            >
              Digital Marketing
            </Link>
          </div>
        </section>
      </section>
      <Footer />
    </>
  );
};

export default Sitemap;
